
import vue from 'vue'
import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import {
initWxJSSDK,
} from '../../../common/js/api.js'
import {
getCookie,
setCookie,
removeCookie
} from '../../../common/js/utils.js'
import {
TMap
} from '../../../common/js/map.js'
import { wxORzfb } from '../../../common/js/config.js';
export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle,
Swiper,
SwiperItem
},
methods: {
randomColor() {
return '#' + Math.floor(Math.random() * 0xffffff).toString(16)
},
routeTerminal(latitude, longitude, location) {
let self = this;

if(wxORzfb == 'wx') {

self.$wechat.openLocation({
latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
name: '回收点位置', // 位置名
address: location, // 地址详情说明
scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
infoUrl: '' 
})
} else if(wxORzfb == 'zfb') {
ap.openLocation({
longitude: longitude,
latitude: latitude,
name: '回收点位置',
address: location,
scale:14
});
}
},
},
data() {
return {
bannerList: [],
detail: this.$route.query.detail,
partnerData: {},
mapBounds: {
lat: {
minY: 999,
maxY: 0
},
lng: {
minX: 999,
maxX: 0
}
},
myLocation: null,
center: {},
map: {},
}
},
created() {},
mounted() {
let self = this;
initWxJSSDK();
if( self.detail != null && self.detail != '' ){
self.partnerData = JSON.parse( self.detail );
if( self.partnerData.introImages && self.partnerData.introImages.length>0 ){
self.bannerList = self.partnerData.introImages;
}else{
self.bannerList = ['../../../static/images/ad_2019010201.jpg','../../../static/images/ad_2019010202.jpg','../../../static/images/ad_2019010203.jpg'];
}
}else{
self.$router.go(-1);
}

if(wxORzfb == 'wx') {
vue.wechat.ready(function(res) {

})
} else if(wxORzfb == 'zfb'){

}
}
}



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/yuePartnerDetail.vue